import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('article-cate/list', { params });
  },
  async add(params: any) {
    return axios.post('article-cate/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('article-cate/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('article-cate/info', { params });
  },
  async delete(params: any) {
    return axios.post('article-cate/delete', qs.stringify(params));
  }
};
